export const RequiredField = () => {
  return (
    <span style={{color: 'red'}}>&nbsp;*</span>
  )
}
